// Shared limits for the browser, multipart endpoint and reviewed conversation.
export const MAX_BRIEF_BYTES = 4 * 1024 * 1024;
export const MAX_BRIEF_TEXT = 6000;
export const MAX_BRIEF_MESSAGE = 8000;
export const BRIEF_ACCEPT = '.doc,.docx,.pdf,.jpg,.jpeg,.png,.webp';
export const BRIEF_EXTENSIONS = ['doc', 'docx', 'pdf', 'jpg', 'jpeg', 'png', 'webp'];
export interface BriefAnalysis {
  readability: 'readable' | 'partial' | 'unreadable';
  text: string;
  warnings: string[];
}
export function briefFileError(file: { name: string; size: number }): string {
  if (!BRIEF_EXTENSIONS.includes(file.name.split('.').at(-1)?.toLowerCase() || '')) return 'Choisissez un document Word (.doc ou .docx), un PDF ou une image JPG, PNG ou WebP.';
  if (file.size <= 0) return 'Ce fichier est vide. Choisissez un autre document.';
  if (file.size > MAX_BRIEF_BYTES) return 'Ce fichier dépasse 4 Mo. Réduisez sa taille ou joignez seulement les pages utiles.';
  return '';
}
export function briefFilename(name: string): string {
  return name.split(/[\\/]/).at(-1)!.replace(/[\u0000-\u001f\u007f-\u009f\u202a-\u202e\u2066-\u2069]/g, '').trim().slice(-120) || 'brief';
}
export function validateBriefAnalysis(value: unknown): BriefAnalysis {
  if (!value || typeof value !== 'object') throw new Error('INVALID_BRIEF_ANALYSIS');
  const v = value as Record<string, unknown>;
  if (!['readable', 'partial', 'unreadable'].includes(String(v.readability)) || typeof v.text !== 'string' || v.text.length > MAX_BRIEF_TEXT || !Array.isArray(v.warnings) || v.warnings.length > 3 || v.warnings.some(w => typeof w !== 'string' || !w.trim() || w.length > 240)) throw new Error('INVALID_BRIEF_ANALYSIS');
  if ((v.readability === 'unreadable') !== !v.text.trim()) throw new Error('INVALID_BRIEF_ANALYSIS');
  return { readability: v.readability as BriefAnalysis['readability'], text: v.text.trim(), warnings: v.warnings as string[] };
}
